import TokenRepo from './token.repo';
import { CustomerCodeConfiguration, CustomerCodeConfigurationDraft, CustomerCodePreview, CustomerCodePreviewRequest, CustomerCodeValidation, emptyCustomerCodeConfiguration } from '../models/customer-code-settings.model';
export class CustomerCodeSettingsError extends Error {
  constructor(public readonly status:number, message:string) {super(message);this.name='CustomerCodeSettingsError';}
}
export class CustomerCodeSettingsRepo {
  constructor(private readonly tokens = new TokenRepo(), private readonly transport: typeof fetch = (...args)=>fetch(...args)) {}
  private async request<T>(path:string, body?:object, token = this.tokens.getToken()):Promise<T> {
    if(!token) throw new CustomerCodeSettingsError(401,'Phiên đăng nhập đã kết thúc.');
    const controller=new AbortController();
    const timeout=setTimeout(()=>controller.abort(),15000);
    try {
      const response=await this.transport(`${process.env.REACT_APP_API_URL || ''}/api/customer-code-settings${path}?v=1.0`, {
        method:body===undefined?'GET':'POST',signal:controller.signal,credentials:'omit',cache:'no-store',
        headers:{Authorization:`Bearer ${token}`,'Content-Type':'application/json',...(process.env.REACT_APP_API_NGROK==='true'?{'ngrok-skip-browser-warning':'true'}:{})},
        ...(body===undefined?{}:{body:JSON.stringify(body)})
      });
      const data=await response.json().catch(()=>null);
      if(!response.ok || data?.code!=='00' || data.result==null) {
        throw new CustomerCodeSettingsError(response.status, response.status===409?'Cấu hình hoặc dữ liệu đã thay đổi. Tải lại và kiểm tra trước khi tiếp tục.':response.status===403?'Bạn không có quyền thực hiện thao tác này.':data?.errorMessage || 'Không tải hoặc cập nhật được cấu hình mã khách hàng.');
      }
      return data.result;
    } catch(error) { if(error instanceof CustomerCodeSettingsError) throw error; throw new CustomerCodeSettingsError(0,'Không kết nối được máy chủ. Vui lòng thử lại.'); }
    finally {clearTimeout(timeout);}
  }
  get() {return this.request<CustomerCodeConfiguration>('');}
  async getRuntime(token?:string|null) {
    try{return await this.request<CustomerCodeConfiguration>('/runtime',undefined,token ?? undefined);}
    catch(error){if(error instanceof CustomerCodeSettingsError && error.status===404)return emptyCustomerCodeConfiguration();throw error;}
  }
  validate(configuration:CustomerCodeConfigurationDraft){return this.request<CustomerCodeValidation>('/validate',configuration);}
  preview(request:CustomerCodePreviewRequest){return this.request<CustomerCodePreview>('/preview',request);}
  activate(request:{expectedVersion:number;configuration:CustomerCodeConfigurationDraft}){return this.request<CustomerCodeConfiguration>('/activate',request);}
}
export const customerCodeSettingsRepo=new CustomerCodeSettingsRepo();
